import { TableStyles } from "react-data-table-component";
import { petcoBodyBG, petcoCharcoal } from '@common/_assets/color-constants.js';

// Available Styles: https://github.com/jbetancur/react-data-table-component/blob/master/src/DataTable/styles.ts
export const dataTableCustomStyles: TableStyles & { rows: { style: any } } = {
    headRow: {
        style: {
            fontFamily: 'petcocirculartt-bold, Roboto',
            fontWeight: 'bold',
            fontSize: '14px',
            lineHeight: '22px',
            letterSpacing: '0.5px',
            textTransform: 'uppercase',
            color: petcoCharcoal,
            border: 'none',
            paddingBottom: '0.25rem',
            minHeight: '30px',
            paddingTop: '1rem'
        }
    },
    rows: {
        style: {
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontSize: '15px',
            lineHeight: '22px',
            letterSpacing: '0.5px',
            color: petcoCharcoal,
            '&:hover': {
                backgroundColor: petcoBodyBG,
            }
        }
    },
    headCells: {
        style: {
            paddingLeft: '10px',
            paddingRight: '10px',
        }
    },
    cells: {
        style: {
            paddingLeft: '10px',
            paddingRight: '10px',
            textAlign: 'text-center',
        }
    }
}

export const dashboardTableStyle = {
    ...dataTableCustomStyles,
    responsiveWrapper: { style: { height: 'calc(100% - 93px)' } },
    noData: {
        style: {
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            marginLeft: '-12px'
        }
    },
    tableWrapper: { style: { height: '100%' } }
}
